module.exports = __webpack_public_path__ + "static/media/default-profile-small.e426ca07.svg";